/* mlb-order.js
   Engine for the catalog bulk order page.

   Rules it holds, and nowhere else:
     - one price ladder, running the whole rail, so no quantity needs a human
     - no setup fee, ever
     - decoration goes in one of the product's own spots, scaled to fit it
     - an order can carry several colourways and they share the minimum
     - the only thing that can block checkout is missing artwork below the MOQ
   All money is in cents. */

(function () {
  "use strict";

  function boot(root) {
    if (root.dataset.mlbReady) return;
    root.dataset.mlbReady = "1";

    var sid = root.id.replace(/^mlb-/, "");
    var cfgEl = document.getElementById("mlb-cfg-" + sid)
             || (root.parentNode && root.parentNode.querySelector('script[id^="mlb-cfg-"]'));
    if (!cfgEl) { return; }

    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); }
    catch (e) { return; }

    var TIERS = (CFG.tiers || []).slice().sort(function (a, b) { return a.q - b.q; });
    var SPOTS = CFG.spots || [];
    var COLORS = CFG.colors || [];
    var SIZES = CFG.sizes || [];
    var VARIANTS = CFG.variants || [];
    var MOQ = CFG.moq || 12;
    var DH = CFG.dhSizes || [];
    if (!TIERS.length || !SIZES.length) { return; }

    /* ---------------- Design Huddle canvases ----------------
       Each entry is [width_in, height_in, template_code], the real library
       from the Merchloop workspace. A location resolves to the largest canvas
       that fits inside its stated maximum, so nothing is ever offered that
       Design Huddle cannot open, and the order carries the exact code. */
    function dhFit(w, h) {
      if (!DH.length || !(w > 0) || !(h > 0)) return "";
      var best = null, bestArea = -1;
      for (var i = 0; i < DH.length; i++) {
        var dw = DH[i][0], dh = DH[i][1];
        if (dw > w + 0.001 || dh > h + 0.001) continue;
        var area = dw * dh;
        if (area > bestArea) { bestArea = area; best = DH[i][2]; }
      }
      return best || "";
    }
    /* metafield spots carry only a printed size like "3 x 3 in" */
    function dhDims(s) {
      if (s.w > 0 && s.h > 0) return [s.w, s.h];
      var m = String(s.max || "").match(/([\d.]+)\s*x\s*([\d.]+)/i);
      return m ? [parseFloat(m[1]), parseFloat(m[2])] : [0, 0];
    }
    SPOTS.forEach(function (s) {
      var d = dhDims(s);
      s.dh = dhFit(d[0], d[1]);
    });

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    /* ---------------- money ---------------- */
    function money(c) {
      return "$" + (c / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function n(x) { return x.toLocaleString("en-US"); }

    /* The real pricing model: every variant carries its own price in Shopify,
       and the quantity breaks are order level automatic discounts, a straight
       percentage off. So the page multiplies out the real variant prices and
       applies the same percentage the checkout will, and the two agree. */
    function pctFor(pieces) {
      var pct = 0;
      for (var i = 0; i < TIERS.length; i++) { if (pieces >= TIERS[i].q) pct = TIERS[i].pct || 0; }
      return pct;
    }
    /* what one piece of this size costs in a given colourway */
    function unitFor(colorName, sizeName) {
      var v = variantFor(colorName, sizeName);
      return (v && v.p) || 0;
    }
    /* the colourway's entry price, the standard sizes rather than the
       extended ones, so the ladder quotes a "from" the customer can trust */
    function baseFor() {
      var lo = 0;
      VARIANTS.forEach(function (v) {
        if (color.n && v.color !== color.n) return;
        if (!v.p) return;
        if (!lo || v.p < lo) lo = v.p;
      });
      return lo;
    }
    function leadFor(pieces) {
      var d = TIERS[0].lead;
      for (var i = 0; i < TIERS.length; i++) { if (pieces >= TIERS[i].q) d = TIERS[i].lead; }
      return d;
    }

    /* ---------------- state ---------------- */
    var qty = {};
    var busy = false;
    var EXTRA_FEE = CFG.extraLoc || 0;
    /* zero means "use the product's own price", which is the normal case */
    var STORE_PRICE = CFG.storePrice || 0;
    /* the variant of the fee product that carries additional imprint
       locations onto the cart. Blank means the fee is shown but not charged */
    var FEE_VARIANT = CFG.feeVariant || 0;
    var extras = [];                     /* [{spot, file}] beyond the primary */
    var color = COLORS[0] || { n: "", h: "#b8bdc2", light: true, img: "" };
    var spot = SPOTS[0] || null;
    var artFile = null;

    /* ---------------- the order is a list of colourways ----------------
       One order can carry several colours, and the minimum is the whole
       order, not one colour: six black and six khaki clears twelve. So the
       quantities are keyed by colourway and size, and the grid is one row
       per colour the customer has added. A single colour order looks exactly
       as it did before, which is the common case and costs no extra clicks. */
    var rows = [];                       /* [{ c: colourway }] in order */
    function qk(c, sk) { return (c && c.n ? c.n : "") + " " + sk; }
    function getQ(c, sk) { return qty[qk(c, sk)] || 0; }
    function setQ(c, sk, v) { qty[qk(c, sk)] = v; }
    function rowIndex(c) {
      for (var i = 0; i < rows.length; i++) { if (rows[i].c === c) return i; }
      return -1;
    }
    function rowsLeft() {
      return COLORS.filter(function (c) { return rowIndex(c) === -1; });
    }

    /* a size is only orderable if the chosen colourway actually has it */
    function variantFor(colorName, sizeName) {
      for (var i = 0; i < VARIANTS.length; i++) {
        var v = VARIANTS[i];
        if ((!colorName || v.color === colorName) && (!sizeName || v.size === sizeName)) return v;
      }
      return null;
    }
    function rowPieces(r) {
      var t = 0;
      SIZES.forEach(function (s) { t += getQ(r.c, s.k); });
      return t;
    }
    function totalPieces() {
      var t = 0;
      rows.forEach(function (r) { t += rowPieces(r); });
      return t;
    }
    function sizeLive(colorName, sizeName) {
      if (!VARIANTS.length) return true;
      var v = variantFor(colorName, sizeName);
      return !!(v && v.ok);
    }

    /* ---------------- the colour rows ---------------- */
    var rowsBox = $("[data-rows]") || $("[data-sizes]");
    var SINGLE = SIZES.length === 1;

    function paintRows() {
      if (!rowsBox) return;
      rowsBox.textContent = "";
      rows.forEach(function (r, ri) {
        var row = document.createElement("div");
        row.className = "mlb-crow" + (SINGLE ? " is-single" : "");

        var head = document.createElement("div");
        head.className = "mlb-crow-head";
        var dot = document.createElement("i");
        dot.className = "mlb-crow-dot";
        dot.style.background = r.c.h || "#b8bdc2";
        var nm = document.createElement("span");
        nm.className = "mlb-crow-name";
        nm.textContent = r.c.n || "One colorway";
        head.appendChild(dot); head.appendChild(nm);

        if (SINGLE) {
          /* nothing to split, so the row is the number */
          var one = document.createElement("input");
          one.type = "number"; one.min = "0"; one.step = "1";
          one.className = "mlb-crow-one";
          one.value = String(getQ(r.c, SIZES[0].k));
          one.setAttribute("aria-label", (r.c.n || "") + " quantity");
          bindQty(one, r.c, SIZES[0].k);
          head.appendChild(one);
        } else {
          var cnt = document.createElement("span");
          cnt.className = "mlb-crow-count";
          cnt.setAttribute("data-rowcount", String(ri));
          head.appendChild(cnt);
        }

        if (rows.length > 1) {
          var x = document.createElement("button");
          x.type = "button"; x.className = "mlb-req-x";
          x.setAttribute("aria-label", "Remove " + (r.c.n || "colorway"));
          x.textContent = "\u00d7";
          x.addEventListener("click", function () {
            SIZES.forEach(function (s) { setQ(r.c, s.k, 0); });
            rows.splice(ri, 1);
            paintRows(); render();
          });
          head.appendChild(x);
        }
        row.appendChild(head);

        if (!SINGLE) {
          var grid = document.createElement("div");
          grid.className = "mlb-sizes";
          SIZES.forEach(function (s) {
            var cell = document.createElement("div");
            cell.className = "mlb-cell";
            cell.setAttribute("data-k", s.k);
            cell.setAttribute("data-ri", String(ri));

            var lab = document.createElement("label");
            lab.textContent = s.k;
            lab.setAttribute("for", "mlb-q-" + root.id + "-" + ri + "-" + s.k.replace(/\W+/g, ""));

            var inp = document.createElement("input");
            inp.type = "number"; inp.min = "0"; inp.step = "1";
            inp.id = lab.getAttribute("for");
            inp.value = String(getQ(r.c, s.k));
            bindQty(inp, r.c, s.k);

            cell.appendChild(lab); cell.appendChild(inp);
            grid.appendChild(cell);
          });
          row.appendChild(grid);
        }

        rowsBox.appendChild(row);
      });

      var add = $("[data-add-color]");
      if (add) add.hidden = rowsLeft().length === 0;
      paintColorPop();
    }

    function bindQty(inp, c, sk) {
      inp.addEventListener("input", function () {
        var v = parseInt(inp.value, 10);
        setQ(c, sk, (isNaN(v) || v < 0) ? 0 : v);
        render();
      });
      inp.addEventListener("focus", function () { inp.select(); });
    }

    /* Adding a colour re-splits what is already in the order across all of
       them, so two colours of twelve is one click and no typing. */
    function addRow(c, rebalance) {
      if (!c || rowIndex(c) !== -1) return;
      var before = totalPieces();
      rows.push({ c: c });
      paintRows();
      if (rebalance && before > 0) { fill(before); } else { render(); }
    }

    /* ---------------- the add a colour popover ---------------- */
    function paintColorPop() {
      var pop = $("[data-colorpop]");
      if (!pop) return;
      pop.textContent = "";
      rowsLeft().forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "mlb-popway";
        b.innerHTML = '<i style="background:' + (c.h || "#b8bdc2") + '"></i>';
        b.appendChild(document.createTextNode(c.n));
        b.addEventListener("click", function () {
          pop.hidden = true;
          var add = $("[data-add-color]");
          if (add) add.setAttribute("aria-expanded", "false");
          addRow(c, true);
          selectColor(c);
        });
        pop.appendChild(b);
      });
    }
    (function () {
      var add = $("[data-add-color]");
      if (!add) return;
      add.addEventListener("click", function () {
        var pop = $("[data-colorpop]");
        if (!pop) return;
        pop.hidden = !pop.hidden;
        add.setAttribute("aria-expanded", String(!pop.hidden));
      });
    })();

    /* One size products have nothing to split, so the row is the number and
       the note about size splits has nothing to say. */
    if (SINGLE) {
      var splitHint = $(".mlb-hint");
      if (splitHint) splitHint.classList.add("is-single");
      var step1 = $("[data-step1]");
      if (step1) step1.textContent = "How many";
    }

    /* Spread a quantity across the colours in the order, then across a normal
       size curve inside each, skipping anything a colourway cannot make. */
    function fill(target) {
      var nr = rows.length || 1;
      var base = Math.floor(target / nr), rem = target - base * nr;
      rows.forEach(function (r, i) { fillRow(r, base + (i < rem ? 1 : 0)); });
      syncCells();
      render();
    }
    function fillRow(r, target) {
      var live = SIZES.filter(function (s) { return sizeLive(r.c.n, s.k); });
      if (!live.length) live = SIZES.slice();

      var w = curve(live.length), left = target, i;
      SIZES.forEach(function (s) { setQ(r.c, s.k, 0); });
      for (i = 0; i < live.length; i++) {
        var got = Math.floor(target * w[i]);
        setQ(r.c, live[i].k, got); left -= got;
      }
      var order = middleOut(live.length);
      i = 0;
      while (left > 0) {
        var k = live[order[i % order.length]].k;
        setQ(r.c, k, getQ(r.c, k) + 1);
        left--; i++;
      }
    }

    /* a plain bell, widest in the middle of the run */
    function curve(len) {
      var w = [], sum = 0, i, mid = (len - 1) / 2;
      for (i = 0; i < len; i++) {
        var d = (i - mid) / (len / 2.6);
        var v = Math.exp(-d * d);
        w.push(v); sum += v;
      }
      return w.map(function (v) { return v / sum; });
    }
    function middleOut(len) {
      var mid = Math.floor((len - 1) / 2), out = [], step = 0;
      while (out.length < len) {
        if (mid - step >= 0 && out.indexOf(mid - step) < 0) out.push(mid - step);
        if (mid + step < len && out.indexOf(mid + step) < 0) out.push(mid + step);
        step++;
      }
      return out;
    }

    function syncCells() {
      if (!rowsBox) return;
      rows.forEach(function (r, ri) {
        if (SINGLE) {
          var one = rowsBox.querySelectorAll(".mlb-crow-one")[ri];
          if (one && document.activeElement !== one) one.value = String(getQ(r.c, SIZES[0].k));
          return;
        }
        SIZES.forEach(function (s) {
          var cell = rowsBox.querySelector('[data-ri="' + ri + '"][data-k="' + cssEsc(s.k) + '"]');
          if (!cell) return;
          var inp = cell.querySelector("input");
          if (inp && document.activeElement !== inp) inp.value = String(getQ(r.c, s.k));
        });
      });
    }
    function cssEsc(v) { return String(v).replace(/"/g, '\\"'); }

    /* ---------------- placement ----------------
       No mockup and no dragging. The product's real decoration spots are the
       only choices offered, so an out of bounds imprint is not reachable and
       nothing has to be corrected by a human later. */
    (function () {
      var box = $("[data-places]");
      if (!SPOTS.length) { box.hidden = true; return; }
      SPOTS.forEach(function (s, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "mlb-place-chip";
        b.textContent = s.name;
        b.setAttribute("aria-pressed", String(i === 0));
        b.addEventListener("click", function () {
          spot = s;
          Array.prototype.forEach.call(box.children, function (o) {
            o.setAttribute("aria-pressed", String(o === b));
          });
          extras = extras.filter(function (e) { return e.spot.k !== s.k; });
          paintExtras();
          var pb = $("[data-places]");
          if (pb) pb.hidden = true;
          if (placeToggle) placeToggle.setAttribute("aria-expanded", "false");
          showMax(); render();
        });
        box.appendChild(b);
      });
    })();

    /* the pill carries the whole answer: where the logo goes and how big it
       can be there. The caret next to it is what says this can change. */
    function showMax() {
      var el = $("[data-place-current]") || $("[data-place-max]");
      if (!el) return;
      el.textContent = spot
        ? spot.name + (spot.max ? " \u00b7 up to " + spot.max : "")
        : "\u2014";
    }

    /* the chips only appear when someone wants a different spot: the default
       is right for most orders, so it is a statement, not an open question */
    var placeToggle = $("[data-place-toggle]");
    if (placeToggle) {
      placeToggle.addEventListener("click", function () {
        var box = $("[data-places]");
        box.hidden = !box.hidden;
        placeToggle.setAttribute("aria-expanded", String(!box.hidden));
      });
    }

    /* ---------------- additional imprint locations ----------------
       The primary location is part of the piece price. Each further location
       is a per piece charge, priced on the tally like everything else, and it
       reuses the primary artwork unless a different file is added. */
    function spotsFree(keepIdx) {
      var used = spot ? [spot.k] : [];
      extras.forEach(function (e, i) { if (i !== keepIdx) used.push(e.spot.k); });
      return SPOTS.filter(function (s) { return used.indexOf(s.k) === -1; });
    }

    function paintExtras() {
      var box = $("[data-extras]");
      if (!box) return;
      box.textContent = "";
      extras.forEach(function (ex, idx) {
        var row = document.createElement("div");
        row.className = "mlb-extra";

        var head = document.createElement("div");
        head.className = "mlb-extra-head";
        var lab = document.createElement("span");
        lab.textContent = "Location " + (idx + 2)
          + (EXTRA_FEE ? " \u00b7 +" + money(EXTRA_FEE) + " per piece" : "");
        var x = document.createElement("button");
        x.type = "button"; x.className = "mlb-req-x";
        x.setAttribute("aria-label", "Remove location " + (idx + 2));
        x.textContent = "\u00d7";
        x.addEventListener("click", function () {
          extras.splice(idx, 1);
          paintExtras(); render();
        });
        head.appendChild(lab); head.appendChild(x);
        row.appendChild(head);

        var chips = document.createElement("div");
        chips.className = "mlb-places";
        var avail = spotsFree(idx);
        if (avail.indexOf(ex.spot) === -1) avail = [ex.spot].concat(avail);
        avail.forEach(function (s) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "mlb-place-chip";
          b.textContent = s.name;
          b.setAttribute("aria-pressed", String(s.k === ex.spot.k));
          b.addEventListener("click", function () { ex.spot = s; paintExtras(); render(); });
          chips.appendChild(b);
        });
        row.appendChild(chips);

        var art = document.createElement("div");
        art.className = "mlb-extra-art";
        var inp = document.createElement("input");
        inp.type = "file"; inp.className = "mlb-file";
        inp.accept = ".ai,.eps,.pdf,.svg,.png,.jpg,.jpeg";
        inp.id = "mlb-exart-" + root.id + "-" + idx;
        var lb = document.createElement("label");
        lb.className = "mlb-upload sm";
        lb.setAttribute("for", inp.id);
        lb.textContent = ex.file ? ex.file.name : "Different art here?";
        var hint = document.createElement("span");
        hint.className = "mlb-arthint";
        hint.textContent = ex.file ? "On file for this spot." : "Otherwise we run your primary logo here.";
        inp.addEventListener("change", function (e2) {
          ex.file = (e2.target.files && e2.target.files[0]) || null;
          paintExtras();
        });
        art.appendChild(lb); art.appendChild(inp); art.appendChild(hint);
        row.appendChild(art);

        box.appendChild(row);
      });
      var addBtn = $("[data-extra-add]");
      if (addBtn) addBtn.hidden = spotsFree(-1).length === 0;
    }

    var extraAdd = $("[data-extra-add]");
    if (extraAdd) {
      /* the second location is the one thing on this step that adds money, so
         it says how much before it is clicked, not after */
      var feeEl = $("[data-extra-fee]");
      if (feeEl) feeEl.textContent = EXTRA_FEE ? "+" + money(EXTRA_FEE) + " each" : "";
      extraAdd.addEventListener("click", function () {
        var avail = spotsFree(-1);
        if (!avail.length) return;
        extras.push({ spot: avail[0], file: null });
        paintExtras(); render();
      });
    }

    /* ---------------- screen one: the stated build ----------------
       Facts the visitor came for, filled from the same config the order
       uses, so the landing card can never disagree with the checkout. */
    function paintSpec() {
      var put = function (sel, txt) { var el = $(sel); if (el) el.textContent = txt; };
      /* The stated build as a row of small icon chips rather than one grey
         sentence: decoration + spot, colourways, size range. Labels are set
         with textContent so a product's own method or spot name can never
         inject markup; the SVGs are static and trusted. */
      var specs = $("[data-specs]");
      if (specs) {
        var ns = "http://www.w3.org/2000/svg";
        var ICON = {
          deco: '<path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>',
          size: '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/>',
          blank: '<circle cx="12" cy="12" r="9"/><path d="m5.6 5.6 12.8 12.8"/>'
        };
        specs.textContent = "";
        var chip = function (icon, label) {
          if (!label) return;
          var li = document.createElement("li");
          li.className = "mlb-spec";
          li.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[icon] + '</svg>';
          var sp = document.createElement("span");
          sp.textContent = label;
          li.appendChild(sp);
          specs.appendChild(li);
        };
        if (!CFG.blank && (CFG.method || spot)) {
          chip("deco", (CFG.method || "Decorated") + (spot ? ", " + spot.name.toLowerCase() : ""));
        } else if (CFG.blank) {
          chip("blank", "Not decorated");
        }
        if (SIZES.length > 1) {
          chip("size", SIZES[0].k + "\u2013" + SIZES[SIZES.length - 1].k);
        } else if (SIZES.length === 1) {
          chip("size", "One size");
        }
      }

      /* One base cost runs both doors: the product's own price in Shopify.
         A company store sells at exactly that, one piece at a time. A direct
         order takes the automatic quantity discount off the same number, so
         the range runs from the largest break to the smallest. */
      var b0 = baseFor();
      var minPct = -1, maxPct = 0;
      TIERS.forEach(function (t) {
        var p = t.pct || 0;
        if (minPct < 0 || p < minPct) minPct = p;
        if (p > maxPct) maxPct = p;
      });
      if (minPct < 0) minPct = 0;
      var hi = Math.round(b0 * (100 - minPct) / 100);
      var lo = Math.round(b0 * (100 - maxPct) / 100);

      var store = STORE_PRICE || b0;
      /* the store price appears in the second door and again inside its own
         panel, so every copy of it moves together */
      var storeTxt = store ? money(store) : "\u2014";
      $$("[data-spec-store], [data-store-price]").forEach(function (el) { el.textContent = storeTxt; });
      put("[data-spec-range]", b0
        ? (lo === hi ? money(hi) + " each" : money(lo) + "\u2013" + money(hi) + " each")
        : "\u2014");
      var sub = $("[data-fork-order-sub]");
      if (sub && b0) sub.textContent = MOQ + " piece minimum \u00b7 from " + money(lo) + " each";
    }
    paintSpec();

    /* ---------------- the fork ----------------
       Screen one is information; these two doors are its only controls.
       Opening a door hides the fork, the back link restores it. */
    var orderOpen = false;
    function setMode(mode) {
      orderOpen = mode === "order";
      $$("[data-panel]").forEach(function (el) {
        el.hidden = el.getAttribute("data-panel") !== mode;
      });
      /* the two paths stay on the page as a chooser rather than vanishing
         once one is taken: the live one is marked, and going back is one
         click on the other, which is why the old back link is gone. */
      $$("[data-fork]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b.getAttribute("data-fork") === mode));
      });
      /* The sales copy has done its job the moment either door is open, so it
         folds away and the panel sits where the visitor is already looking.
         Either door: the description and the reassurances are selling the
         product, and past the choice the visitor is configuring, not being
         sold to. Closing both doors brings it all back. */
      var open = !!mode;
      var hi = $("[data-hilite]");
      if (hi) hi.classList.toggle("is-compact", open);
      var blurb = $(".mlb-blurb");
      if (blurb) blurb.classList.toggle("is-compact", open);
      var desc = $(".mlb-desc");
      if (desc) desc.classList.toggle("is-compact", open);
    }
    /* Nothing is open on arrival: the page offers two doors and waits, so the
       first thing a visitor does is tell us which of the two they are. An
       empty mode closes both again, which is what clicking the open one does. */
    $$("[data-fork]").forEach(function (b) {
      b.addEventListener("click", function () {
        setMode(b.getAttribute("aria-pressed") === "true" ? "" : b.getAttribute("data-fork"));
      });
    });

    /* ---------------- image gallery and colorways ----------------
       These are one control, not two. A colourway photo is the thing most
       visitors reach for first, so clicking a thumbnail picks that colourway,
       the same as clicking its swatch: the name, the swatch, the price and
       the sizes all follow. */
    var wayBtns = [];

    /* thumbnails and colourway photos come from the same image_url call, so a
       plain compare finds the colourway a thumbnail belongs to */
    function imgKey(u) { return String(u || "").split("?")[0]; }
    function colorForImage(u) {
      var k = imgKey(u);
      if (!k) return null;
      for (var i = 0; i < COLORS.length; i++) {
        if (COLORS[i].img && imgKey(COLORS[i].img) === k) return COLORS[i];
      }
      return null;
    }
    function showImage(u) {
      var im = $("[data-img]");
      if (im && u) im.src = u;
      var k = imgKey(u);
      $$(".mlb-thumb").forEach(function (o) {
        o.setAttribute("aria-pressed", String(imgKey(o.getAttribute("data-full")) === k));
      });
    }

    function selectColor(c, keepImage) {
      if (!c) return;
      color = c;
      wayBtns.forEach(function (o) { o.setAttribute("aria-pressed", String(o.mlbColor === c)); });
      var nm = $("[data-wayname]");
      if (nm) nm.textContent = c.n;
      if (!keepImage && c.img) showImage(c.img);

      /* Before the order is open the visitor is only looking, so the one row
         follows what they are looking at. Once the order is open a different
         swatch means a different colourway on the order, which is the whole
         point of the grid, so it joins as a row and the pieces re-split. */
      /* Ordering is open from the moment the page loads now, so a swatch is
         no longer a signal to add a colorway to the order, it is the visitor
         looking at one. It swaps the row they have; "+ Add a color" is the
         only thing that adds a row. */
      if (rows.length === 1 && rows[0].c !== c) {
        var had = rowPieces(rows[0]);
        SIZES.forEach(function (s) { setQ(rows[0].c, s.k, 0); });
        rows[0].c = c;
        paintRows();
        if (had > 0) { fillRow(rows[0], had); syncCells(); }
      }

      paintLadder();
      paintSpec();
      /* if a colourway cannot make a size that had pieces in it, move those
         pieces onto sizes it can rather than leaving a dead line */
      var stranded = rows.some(function (r) {
        return SIZES.some(function (s) { return getQ(r.c, s.k) > 0 && !sizeLive(r.c.n, s.k); });
      });
      if (stranded) { fill(totalPieces()); } else { render(); }
    }

    $$(".mlb-thumb").forEach(function (b) {
      b.addEventListener("click", function () {
        var full = b.getAttribute("data-full");
        showImage(full);
        var hit = colorForImage(full);
        if (hit && hit !== color) selectColor(hit, true);
      });
    });

    (function () {
      var box = $("[data-ways]");
      if (!COLORS.length) { box.hidden = true; return; }
      COLORS.forEach(function (c, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "mlb-way";
        b.mlbColor = c;
        b.setAttribute("aria-label", c.n);
        b.setAttribute("aria-pressed", String(i === 0));
        b.innerHTML = '<i style="background:' + c.h + '"></i>';
        b.addEventListener("click", function () { selectColor(c); });
        box.appendChild(b);
        wayBtns.push(b);
      });
      var name = document.createElement("span");
      name.className = "mlb-wayname";
      name.setAttribute("data-wayname", "");
      name.textContent = color.n;
      box.appendChild(name);
    })();

    /* ---------------- artwork ----------------
       The file is only ever a file. Where it goes is a choice from the spots
       above, never a drag, so there is nothing to correct later. */
    $("[data-art]").addEventListener("change", function (e) {
      artFile = (e.target.files && e.target.files[0]) || null;
      $("[data-art-label]").textContent = artFile ? artFile.name : (CFG.uploadLabel || "Add your logo");
      $("[data-art-hint]").innerHTML = artFile
        ? '<span class="mlb-artok">Got it.</span> You approve a proof before we print anything.'
        : "AI, EPS, PDF, SVG or PNG";
      render();
    });

    /* ---------------- the ladder ----------------
       Every break, one thin strip: the price transparency, the presets, and
       the quantity scale in a single row. Tapping a break fills the sizes. */
    (function () {
      var box = $("[data-ticks]");
      TIERS.forEach(function (t) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "mlb-lad";
        b.setAttribute("data-qty", String(t.q));
        b.setAttribute("aria-pressed", "false");
        b.setAttribute("data-pct", String(t.pct || 0));
        b.innerHTML = "<b>" + n(t.q) + "</b><small></small>";
        b.addEventListener("click", function () { fill(t.q); });
        box.appendChild(b);
      });
    })();

    /* the ladder is priced off the product in front of you, so it repaints
       whenever the colourway changes the base price */
    function paintLadder() {
      var base = baseFor();
      $$(".mlb-lad").forEach(function (b) {
        var pct = parseFloat(b.getAttribute("data-pct")) || 0;
        var small = b.querySelector("small");
        if (small) small.textContent = base ? money(Math.round(base * (100 - pct) / 100)) : (pct + "% off");
      });
    }

    var qnum = $("[data-qnum]");
    qnum.addEventListener("input", function () {
      var v = parseInt(qnum.value, 10);
      if (!isNaN(v) && v > 0) fill(v);
    });
    qnum.addEventListener("blur", function () {
      var v = parseInt(qnum.value, 10);
      if (isNaN(v) || v < 1) fill(MOQ);
    });
    qnum.addEventListener("focus", function () { qnum.select(); });

    /* ---------------- render ---------------- */
    function render() {
      var pieces = 0, subtotal = 0;
      rows.forEach(function (r, ri) {
        var rp = 0;
        SIZES.forEach(function (s) {
          var q = getQ(r.c, s.k);
          rp += q;
          subtotal += q * unitFor(r.c.n, s.k);
          var cell = rowsBox && rowsBox.querySelector('[data-ri="' + ri + '"][data-k="' + cssEsc(s.k) + '"]');
          if (cell) {
            cell.classList.toggle("has", q > 0);
            cell.classList.toggle("off", !sizeLive(r.c.n, s.k));
          }
        });
        pieces += rp;
        var cnt = rowsBox && rowsBox.querySelector('[data-rowcount="' + ri + '"]');
        if (cnt) cnt.textContent = n(rp) + (rp === 1 ? " piece" : " pieces");
      });

      var pct = pctFor(pieces);
      var save = Math.round(subtotal * pct / 100);
      var extraTotal = extras.length * pieces * EXTRA_FEE;
      var total = subtotal - save + extraTotal;
      var base = baseFor();
      var each = pieces > 0 ? Math.round((subtotal - save) / pieces) : Math.round(base * (100 - pct) / 100);

      $("[data-each]").textContent = money(each);
      $("[data-eachsub]").textContent = "each at " + n(pieces > 0 ? pieces : MOQ)
        + (pieces === 1 ? " piece" : " pieces")
        + (pct ? ", " + pct + "% off" : "")
        + (spot ? ", " + (CFG.method || "decorated").toLowerCase() + " " + spot.name.toLowerCase() : "");
      /* when, standing next to how much */
      var ship = $("[data-ship]");
      if (ship) ship.textContent = "Ships in " + leadFor(pieces) + " business days";

      if (document.activeElement !== qnum) qnum.value = String(pieces);

      $$(".mlb-lad").forEach(function (b) {
        var q = parseInt(b.getAttribute("data-qty"), 10);
        b.setAttribute("aria-pressed", String(pct === (parseFloat(b.getAttribute("data-pct")) || 0) && pieces >= q));
      });

      var tally = "";
      if (pieces === 0) {
        tally = '<div class="mlb-r"><span>Pick your sizes, or tap a quantity above</span><span>&mdash;</span></div>';
      } else {
        var many = rows.length > 1;
        tally += '<div class="mlb-r"><span>' + n(pieces) + ' pieces'
          + (many ? ' across ' + rows.length + ' colorways' : '')
          + '</span><span>' + money(subtotal) + '</span></div>';
        if (save > 0) {
          tally += '<div class="mlb-r"><span>Quantity discount, ' + pct + '% off</span><span>&minus;' + money(save) + '</span></div>';
        }
        extras.forEach(function (ex) {
          tally += '<div class="mlb-r"><span>' + ex.spot.name + ' imprint</span><span>'
            + money(pieces * EXTRA_FEE) + '</span></div>';
        });
        tally += '<div class="mlb-r total"><span>Total</span><span>' + money(total) + '</span></div>';
      }
      $("[data-tally]").innerHTML = tally;

      var flag = $("[data-flag]"), cta = $("[data-cta]");
      flag.className = "mlb-flag"; flag.hidden = true;

      /* the minimum is a hard floor, not a nudge: the numbers go red, the
         message goes red, and the button stays shut until it is met. It is
         the whole order that has to clear it, colourways included. */
      var under = pieces > 0 && pieces < MOQ;
      qnum.classList.toggle("is-bad", under);
      qnum.setAttribute("aria-invalid", under ? "true" : "false");
      if (rowsBox) {
        $$(".mlb-cell").forEach(function (cell) {
          cell.classList.toggle("is-bad", under && cell.classList.contains("has"));
        });
        $$(".mlb-crow-one").forEach(function (one) {
          one.classList.toggle("is-bad", under && (parseInt(one.value, 10) || 0) > 0);
        });
      }

      if (under) {
        flag.hidden = false; flag.className = "mlb-flag warn";
        flag.textContent = "Direct orders start at " + MOQ + " pieces. Add "
          + (MOQ - pieces) + " more to check out, in any mix of colors, or put this on a company store, which has no minimum.";
      } else if (CFG.blank && pieces >= MOQ) {
        flag.hidden = false;
        flag.textContent = "This item ships blank, no logo or decoration needed.";
      } else if (!artFile && pieces >= MOQ) {
        flag.hidden = false;
        flag.textContent = "Add your logo to check out. It is the one thing we cannot start without.";
      }

      cta.disabled = pieces < MOQ || (!CFG.blank && !artFile) || busy;
      /* no setup fees is promised in the checks above the order, and the ship
         date now sits with the price, so this says the one thing left */
      $("[data-fine]").textContent = MOQ + " piece minimum";
    }

    /* ---------------- add to cart ----------------
       One request per colourway and size, because a line item file property
       is only accepted on a single item add. The artwork rides on the first
       line and every line carries the placement and the colourway so nothing
       has to be looked up later. */
    function lines() {
      var out = [];
      rows.forEach(function (r) {
        SIZES.forEach(function (s) {
          var q = getQ(r.c, s.k);
          if (!q) return;
          var v = variantFor(r.c.n, s.k);
          if (v) out.push({ id: v.id, q: q, size: s.k, color: r.c.n || "" });
        });
      });
      return out;
    }

    $("[data-cta]").addEventListener("click", function () {
      if (busy) return;
      var L = lines();
      if (!L.length) { toast("Those sizes are not available right now."); return; }

      busy = true; render();
      var cta = $("[data-cta]"), label = cta.textContent;
      cta.textContent = "Adding\u2026";

      /* Every extra imprint location is a real per piece charge, so it goes
         on the cart as its own line rather than being shown on the page and
         quietly dropped. One line, quantity equal to the pieces it decorates,
         at the fee product's own price. */
      if (FEE_VARIANT && EXTRA_FEE && extras.length) {
        var feePieces = L.reduce(function (a, l) { return a + l.q; }, 0);
        extras.forEach(function (ex) {
          L.push({ id: FEE_VARIANT, q: feePieces, fee: true, spot: ex.spot.name });
        });
      }

      var i = 0;
      function next() {
        if (i >= L.length) {
          busy = false; cta.textContent = label; render();
          toast(n(L.reduce(function (a, l) { return a + (l.fee ? 0 : l.q); }, 0)) + " added to your cart.");
          document.dispatchEvent(new CustomEvent("mlb:added"));
          window.location.href = "/cart";
          return;
        }
        var l = L[i];
        var fd = new FormData();
        fd.append("id", l.id);
        fd.append("quantity", l.q);

        if (l.fee) {
          fd.append("properties[Location]", l.spot);
          fd.append("properties[On]", CFG.title || "");
          fd.append("properties[_bulk_catalog]", "true");
          fetch("/cart/add.js", { method: "POST", body: fd, credentials: "same-origin" })
            .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
            .then(function () { i++; next(); })
            .catch(function () { i++; next(); });
          return;
        }

        fd.append("properties[Placement]", spot ? spot.name : "");
        if (spot && spot.dh) fd.append("properties[Design template]", spot.dh);
        extras.forEach(function (ex, k) {
          fd.append("properties[Location " + (k + 2) + "]", ex.spot.name
            + (ex.spot.dh ? " (" + ex.spot.dh + ")" : ""));
        });
        fd.append("properties[Decoration]", CFG.blank ? "None" : (CFG.method || ""));
        if (l.color) fd.append("properties[Colorway]", l.color);
        if (i === 0 && artFile) fd.append("properties[Artwork]", artFile, artFile.name);
        if (i === 0) {
          extras.forEach(function (ex) {
            if (ex.file) fd.append("properties[Artwork - " + ex.spot.name + "]", ex.file, ex.file.name);
          });
        }
        fd.append("properties[_bulk_catalog]", "true");

        fetch("/cart/add.js", { method: "POST", body: fd, credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
          .then(function () { i++; next(); })
          .catch(function (err) {
            busy = false; cta.textContent = label; render();
            toast((err && err.description) || "That size ran out while you were building. Adjust and try again.");
          });
      }
      next();
    });

    /* ---------------- store request ----------------
       A list, not a checkout. It persists across product pages so a browser
       can collect several styles and send one request. localStorage can be
       unavailable, so every touch is guarded and the page works without it,
       it just forgets the list between products. */
    var REQ_KEY = "mlbStoreRequest";
    function reqRead() {
      try { return JSON.parse(localStorage.getItem(REQ_KEY) || "[]") || []; }
      catch (e) { return reqMem; }
    }
    function reqWrite(list) {
      reqMem = list;
      try { localStorage.setItem(REQ_KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent("mlb:req-updated"));
    }
    var reqMem = [];

    function reqPaint() {
      var wrap = $("[data-req]"), listEl = $("[data-req-list]");
      if (!wrap || !listEl) return;
      var list = reqRead();
      wrap.hidden = list.length === 0;
      var count = $("[data-req-count]");
      /* the count sits in the panel header now, not inside the list, so it
         says nothing at all rather than "0 styles" before anything is added */
      if (count) count.textContent = list.length
        ? list.length + (list.length === 1 ? " style" : " styles")
        : "";
      listEl.textContent = "";
      list.forEach(function (item) {
        var row = document.createElement("div");
        row.className = "mlb-req-item";
        var img = document.createElement("img");
        img.src = item.img || ""; img.alt = ""; img.width = 34; img.height = 34;
        var name = document.createElement("span");
        name.textContent = item.title + (item.color ? " \u00b7 " + item.color : "");
        var x = document.createElement("button");
        x.type = "button"; x.className = "mlb-req-x";
        x.setAttribute("aria-label", "Remove " + item.title);
        x.textContent = "\u00d7";
        x.addEventListener("click", function () {
          reqWrite(reqRead().filter(function (o) { return !(o.h === item.h && o.color === item.color); }));
          reqPaint();
        });
        row.appendChild(img); row.appendChild(name); row.appendChild(x);
        listEl.appendChild(row);
      });
    }

    var reqAdd = $("[data-req-add]");
    if (reqAdd) {
      reqAdd.addEventListener("click", function () {
        var list = reqRead();
        var dup = list.some(function (o) { return o.h === CFG.handle && o.color === (color.n || ""); });
        if (!dup) {
          /* carry the product's real decoration spots so the tray can confirm
             the print location before sending. Blank products carry none. */
          var spotList = CFG.blank ? [] : (SPOTS || []).map(function (s) { return { n: s.name, m: s.max || "" }; }).filter(function (s) { return s.n; });
          list.push({
            h: CFG.handle, title: CFG.title || CFG.handle, color: color.n || "",
            img: CFG.thumb || "", blank: !!CFG.blank,
            method: CFG.blank ? "" : (CFG.method || ""),
            spots: spotList, loc: spotList[0] ? spotList[0].n : "", det: 1
          });
          reqWrite(list);
        }
        reqPaint();
        toast(dup ? "Already on your request." : "Added. Keep browsing, or send the request when your list is ready.");
      });
    }

    /* the questions and the send live in the tray, so this hands off to it */
    var openBtn = $("[data-req-open]");
    if (openBtn) {
      openBtn.addEventListener("click", function () {
        document.dispatchEvent(new CustomEvent("mlb:req-open"));
      });
    }

    document.addEventListener("mlb:req-updated", reqPaint);

    /* ---------------- toast ---------------- */
    var tTimer;
    function toast(msg) {
      var t = $("[data-toast]");
      t.textContent = msg; t.classList.add("up");
      clearTimeout(tTimer);
      tTimer = setTimeout(function () { t.classList.remove("up"); }, 3600);
    }

    /* ---------------- description read more ----------------
       The product blurb can run long, so it clamps to a few lines and a
       toggle opens the rest. The toggle hides itself when the text is short
       enough that there is nothing to expand. */
    (function () {
      var wrap = $("[data-desc]"), text = $("[data-desc-text]"), more = $("[data-desc-more]");
      if (!wrap || !text || !more) return;
      /* Clamp is added by JS so that, if the script never runs, the full
         description shows rather than a truncation with no way to open it. */
      wrap.classList.add("is-clamped");
      function check() {
        var overflow = text.scrollHeight > text.clientHeight + 2;
        more.hidden = !overflow && !wrap.classList.contains("is-open");
      }
      more.addEventListener("click", function () {
        var open = wrap.classList.toggle("is-open");
        more.textContent = open ? "Read less" : "Read more";
        more.setAttribute("aria-expanded", String(open));
      });
      check();
      window.addEventListener("resize", check);
    })();

    /* ---------------- go ---------------- */
    rows.push({ c: color });
    paintRows();
    showMax();
    paintLadder();
    paintExtras();
    reqPaint();
    fill(CFG.defaultQty || MOQ);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-mlb]"), boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();